// Copy rendered in a step's footer, below the submit button. Shared by
// StepWrapper (which covers most step types) and the steps that render their
// own footer.
import React from "react";
import styles from "../../steps/steps.module.scss";
import hasVisibleContent from "../../utils/hasVisibleContent";

interface StepFooterTextProps {
  // HTML is supported, same convention as the other config-authored copy.
  text?: string;
}

export default function StepFooterText({ text }: StepFooterTextProps) {
  if (!hasVisibleContent(text)) {
    return null;
  }

  // A div, not a p: the editor emits its own <p> per paragraph, and a <p>
  // cannot nest — the browser would close the wrapper early and drop
  // styles.textLinks from everything after the first block.
  return (
    <div
      className={`${styles.textLinks} f-4 gray-8 lh-4 mt-6 mb-0`}
      dangerouslySetInnerHTML={{ __html: text }}
    />
  );
}
